import { UISK_Variables } from "./generatedTheme"
import { StyledComponentsTheme } from "./generateUISKTheme"

export const cleanKeys = <
  T extends keyof UISK_Variables,
  S extends keyof StyledComponentsTheme,
>(
  object: UISK_Variables[T],
  string: S,
) =>
  Object.fromEntries(
    Object.entries(object).map(([key, value]) => [
      key.replace(`${string}-`, "").replace(`-${string}`, ""),
      value,
    ]),
  ) as StyledComponentsTheme[S]
